module.exports = __webpack_public_path__ + "1793882494189/images/asia.91a3dee.png";